import tokenProvider from "axios-token-interceptor";
import store from "@/store";

export function request(config) {
  const { isAuthenticated, authToken } = store.getters;

  if (isAuthenticated) {
    return tokenProvider({
      header: "X-PERSONAL-ACCOUNT-KEY",
      headerFormatter: token => token,
      getToken: () => authToken
    })(config);
  }

  return config;
}
